<template>
  <div class="bg-[#23242A] text-white app-header custom">
    <div
      v-if="vg_selectedLocation.id"
      :class="
        'p-4 flex content-main gap-5' + (action.component ? ' half-it' : '')
      "
    >
      <div class="custom-full custom-left">
        <div class="">
          <div
            class="flex justify-between shadow-xl box-border items-center text-white h-[76px] rounded p-4 bg-[#2B2C32] mb-4"
          >
            <h2 class="font-bold text-2xl leading-[30px] tracking-[0.05px]">
              Sales Summary Report
            </h2>
            <div class="flex flex-row items-center gap-6">
              <button
                @click.prevent="exportReport"
                class="h-[44px] py-2 px-4 cursor-pointer flex justify-center disabled:bg-theme-grey hover:opacity-60 items-center bg-white rounded-md font-medium text-sm leading-[17.5px] tracking-[1.2px] text-[#2BA66B]"
              >
                Export
              </button>
              <button
                @click="submit"
                class="h-[44px] py-2 px-4 cursor-pointer bg-white flex justify-center hover:opacity-60 items-center rounded-md font-medium text-sm leading-[17.5px] tracking-[1.2px] text-[#2BA66B]"
              >
                RUN REPORT
              </button>
            </div>
          </div>
          <div
            class="flex flex-col justify-start shadow-xl box-border text-white h-auto rounded p-4 bg-[#2B2C32] mb-2"
          >
            <h3
              class="font-bold text-base leading-5 mb-[18px] tracking-[0.15px]"
            >
              Select a type:
            </h3>
            <div
              class="flex items-center gap-[18px] border-b border-[#464851] pb-4"
            >
              <div class="flex items-center">
                <input
                  :checked="true"
                  value="product"
                  id="byProduct"
                  @click="selectType('product')"
                  type="radio"
                  name="selectType"
                  class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  for="byProduct"
                  class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                  >By product</label
                >
              </div>
              <div class="flex items-center">
                <input
                  id="byOrder"
                  value="order"
                  @click="selectType('order')"
                  type="radio"
                  name="selectType"
                  class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  for="byOrder"
                  class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                  >By order id</label
                >
              </div>
              <div class="flex items-center">
                <input
                  id="byLocation"
                  value="location"
                  @click="selectType('location')"
                  type="radio"
                  name="selectType"
                  class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  for="byLocation"
                  class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                  >By location</label
                >
              </div>
              <div class="flex items-center">
                <input
                  id="byDay"
                  value="day"
                  @click="selectType('day')"
                  type="radio"
                  name="selectType"
                  class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  for="byDay"
                  class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                  >By Day</label
                >
              </div>
              <div class="flex items-center">
                <input
                  id="byLot"
                  value="lot"
                  @click="selectType('lot')"
                  type="radio"
                  name="selectType"
                  class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  for="byLot"
                  class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                  >By Lot</label
                >
              </div>
            </div>

            <!-- BY PRODUCT -->
            <h3 v-if="selectedType==='product'" class="font-bold text-base mb-8 tracking-[0.15px] pt-4">
              By Product
            </h3>
            <h3 v-else-if="selectedType==='order'" class="font-bold text-base mb-8 tracking-[0.15px] pt-4">
              By Order
            </h3>
            <h3 v-if="selectedType==='location'" class="font-bold text-base mb-8 tracking-[0.15px] pt-4">
              By Location
            </h3>
            <h3 v-if="selectedType==='day'" class="font-bold text-base mb-8 tracking-[0.15px] pt-4">
              By Day
            </h3>
            <h3 v-if="selectedType==='lot'" class="font-bold text-base mb-8 tracking-[0.15px] pt-4">
              By Lot
            </h3>
            <div class="flex xl:items-end xl:flex-row flex-col gap-4 mb-3">
              <div class="xl:w-1/4 w-full">
                <div
                  class="flex flex-col re-date"
                  :class="'input-wrapper ' + filter.fromDate.error_type"
                >
                  <label class="mb-0 text-xs">Start Date *</label>
                  <div class="relative justify-center align-center input-clear ">
                    <svg
                      width="16"
                      class="absolute z-[99] left-[10px] bottom-[12px]"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                        fill="white"
                      />
                    </svg>

                    <Datepicker
                      :clearable="true"
                      v-model="filter.fromDate.value"
                      :inputFormat="'yyyy-MM-dd'"
                      :upperLimit="filter.toDate.value"
                      :class="
                        filter.fromDate.value ? 'text-[#fff]' : 'text-[#9E9E9E]'
                      "
                      class="h-[40px] rounded-md bg-gray-black w-full border-none text-base leading-5 pl-[34px]"
                      placeholder="Select a Date"
                    />
                  </div>
                  <p
                    class="field-error label-text mt-1"
                    v-if="filter.fromDate.error_message"
                    v-text="filter.fromDate.error_message"
                  ></p>
                  <p class="field-error label-text mt-1" v-else>&nbsp;</p>
                </div>
              </div>

              <div class="xl:w-1/4 w-full">
                <div
                  class="flex flex-col re-date"
                  :class="'input-wrapper ' + filter.toDate.error_type"
                >
                  <label class="mb-0 text-xs">End Date *</label>
                  <div class="relative justify-center align-center input-clear ">
                    <svg
                      width="16"
                      class="absolute z-[99] left-[10px] bottom-[12px]"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                        fill="white"
                      />
                    </svg>

                    <Datepicker
                      :clearable="true"
                      v-model="filter.toDate.value"
                      :inputFormat="'yyyy-MM-dd'"
                      :lowerLimit="filter.fromDate.value"
                      :class="
                        filter.toDate.value ? 'text-[#fff]' : 'text-[#9E9E9E]'
                      "
                      class="h-[40px] rounded-md bg-gray-black w-full border-none text-base leading-5 pl-[34px]"
                      placeholder="Select a Date"
                    />
                  </div>
                  <p
                    class="field-error label-text mt-1"
                    v-if="filter.toDate.error_message"
                    v-text="filter.toDate.error_message"
                  ></p>
                  <p class="field-error label-text mt-1" v-else>&nbsp;</p>
                </div>
              </div>

              <div class="xl:w-1/4 w-full">
                <div
                  :class="
                    'input-wrapper relative ' + filter.locationIds.error_type
                  "
                >
                  <label class="mb-0 text-xs">Locations *</label>
                  <SelectLocation
                    class="bg-gray-black rounded relative"
                    v-model="filter.locationIds.value"
                    :options="vg_locations"
                    placeholder="Select all that apply"
                  />
                  <p
                    class="field-error label-text mt-1"
                    v-if="filter.locationIds.error_message"
                    v-text="filter.locationIds.error_message"
                  ></p>
                  <p class="field-error label-text mt-1" v-else>&nbsp;</p>
                </div>
              </div>

              <div v-if="selectedType === 'product'" class="xl:w-1/4 w-full">
                <div
                  :class="
                    'input-wrapper flex flex-col ' +
                    filter.products.error_type
                  "
                >
                  <div class="flex flex-row gap-3 items-end">
                    <div class="w-full">
                      <label class="mb-0 text-xs">Products</label>
                      <label
                        for="select"
                        class="h-[40px] flex justify-start items-center rounded-md bg-gray-black w-full border-none text-base leading-5 p-2"
                      >
                        <div
                          :class="
                            filter.products.value.length > 0
                              ? 'text-[#fff]'
                              : 'text-[#9E9E9E]'
                          "
                        >
                          {{
                            filter.products.value.length > 0
                              ? `${filter.products.value.length} Selected`
                              : 'Select all that apply'
                          }}
                        </div>
                      </label>
                    </div>
                    <button
                      id="select"
                      @click="openCategoryProductModal()"
                      class="h-[40px] w-[92px] cursor-pointer hover:opacity-50 uppercase rounded-md py-2 px-4 border border-[#2BA66B] font-medium text-sm leading-[17.5px] tracking-[2px] text-[#2BA66B]"
                    >
                      Select
                    </button>
                  </div>
                  <p
                    class="field-error label-text mt-1"
                    v-if="filter.products.error_message"
                    v-text="filter.products.error_message"
                  ></p>
                  <p class="field-error label-text mt-1" v-else>&nbsp;</p>
                </div>
              </div>

              <div v-else-if="selectedType === 'order'" class="xl:w-1/4 w-full">
                <div
                  :class="
                    'input-wrapper flex flex-col ' +
                    filter.invoiceNumber.error_type
                  "
                >
                  <label class="mb-0 text-xs">Order ID</label>
                  <input
                    v-model="filter.invoiceNumber.value"
                    :class="' h-[40px] flex justify-start items-center placeholder-[#9E9E9E] rounded-md bg-gray-black w-full border-none text-base leading-5 p-2'"
                    placeholder="Enter order #"
                    type="text"
                  />
                  <p
                    class="field-error label-text mt-1"
                    v-if="filter.invoiceNumber.error_message"
                    v-text="filter.invoiceNumber.error_message"
                  ></p>
                  <p class="field-error label-text mt-1" v-else>&nbsp;</p>
                </div>
              </div>
              <div v-else-if="selectedType === 'lot'" class="xl:w-1/4 w-full">
                <div class="input-wrapper flex flex-col">
                  <label class="mb-0 text-xs">Lot Names (optional)</label>
                  <input
                    v-model="filter.lotNames.value"
                    :class="' h-[40px] flex justify-start items-center placeholder-[#9E9E9E] rounded-md bg-gray-black w-full border-none text-base leading-5 p-2'"
                    placeholder="e.g. lot-1, lot-2"
                    type="text"
                  />
                  <p class="field-error label-text mt-1">&nbsp;</p>
                </div>
              </div>
            </div>

            <div class="grid xl:items-end xl:grid-cols-4 gap-4 mb-3">
              <div v-if="selectedType === 'order'" class=" w-full">
                <div
                  class="input-wrapper relative"
                >
                  <label class="mb-0 text-xs">In Delivery/Pickup</label>
                  <div>
                    <select class="bg-gray-black rounded relative w-full" v-model="filter.orderReceiveMethod.value">
                      <option value="">Select One</option>
                      <option value="pickup">Pickup</option>
                      <option value="delivery">Delivery</option>
                    </select>
                  </div>
                </div>
              </div>

              <div v-if="selectedType === 'order'" class=" w-full">
                <div
                  class="input-wrapper relative"
                >
                  <label class="mb-0 text-xs">In Online/In-Store Sale</label>
                  <div>
                    <select class="bg-gray-black rounded relative w-full"  v-model="filter.orderReceiveFrom.value">
                      <option value="">Select One</option>
                      <option value="instore">In Store</option>
                      <option value="online">Online</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class=" w-full">
                <h5 class="font-normal text-xs leading-5 mb-2 tracking-[0.15px]">
                  Export File Format
                </h5>
                <div class="flex items-center gap-[18px] mb-3">
                  <!-- <div class="flex items-center">
                    <input
                      checked
                      @click="selectFormat('sheet')"
                      id="sheet"
                      value="sheet"
                      type="radio"
                      name="no_reward"
                      class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label
                      for="sheet"
                      class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                      >Google Sheet</label
                    >
                  </div> -->
                  <div class="flex items-center">
                    <input
                      checked
                      @click="selectFormat('sheet')"
                      id="format"
                      value="csv"
                      type="radio"
                      name="no_reward"
                      class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label
                      for="format"
                      class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                      >XLSX</label
                    >
                  </div>
                </div>
              </div>
            </div>
            

            <List
              v-if="payload.length > 0"
              :payload="payload"
              :sumPayload="sumPayload"
              :selectedType="selectedType"
              :selectedCallback="selectedItem"
              :is="action.component"
              :clearComponent="clearComponent"
              :reloadComponent="reloadComponent"
              :iscomponentactive="action.component ? true : false"
            />
            <div class="text-theme-red" v-else-if="loaded">
              No Data Found.
            </div>
          </div>
        </div>
      </div>

      <div
        :class="'w-full hidden-component custom-right'"
        v-if="action.component"
      >
        <component
          :is="action.component"
          :item="action.data"
          :clearComponent="clearComponent"
        ></component>
      </div>
    </div>

    <div class="flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl" v-else>
      <div class="w-full">
        <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
          <p class="text-center text-theme-red">
            Please select a location from the top left corner.
          </p>
        </div>
      </div>
    </div>
    <CategoryWithProductModal
      v-if="categoryProductPop"
      :showProductOnly="false"
      :existingproducts="filter.products.value"
      :closeClick="closeCategoryWithProductModal"
      :actionClick="setCategoriesWithProduct"
    />
  </div>
</template>


<script>
import { defineComponent, ref } from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import List from '@/views/Reports/Sales/List.vue'
import Helpers from '@/helpers'
import Datepicker from 'vue3-datepicker'
import SelectLocation from '@/components/form/SelectLocations'
import CategoryWithProductModal from '@/components/CategoriesWithProductModal.vue';
import moment from 'moment-timezone'
import writeXlsxFile from 'write-excel-file'
import ReportApis from '@/controllers/ReportApis'
import ReportHelpers from '@/helpers/report'

export default defineComponent({
  name: 'SalesSummary',
  components: {
    List,
    Datepicker,
    SelectLocation,
    CategoryWithProductModal
  },

  setup() {
    const snackbar = useSnackbar();
    const filter = ref({
      fromDate: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required']
      },
      toDate: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required']
      },
      products: {
        value: [],
        error_type: '',
        error_message: '',
        validations: []
      },
      locationIds: {
        value: [],
        error_type: '',
        error_message: '',
        validations: ['required']
      },
      invoiceNumber: {
        value: '',
        error_type: '',
        error_message: '',
        validations: []
      },
      orderReceiveMethod: {
        value: '',
        error_type: '',
        error_message: '',
        validations: []
      },
      orderReceiveFrom: {
        value: '',
        error_type: '',
        error_message: '',
        validations: []
      },
      lotNames: {
        value: '',
        error_type: '',
        error_message: '',
        validations: []
      },
      type: {
        value: 'sheet',
        error_type: '',
        error_message: '',
        validations: []
      }
    })
    const action = ref({
      component: '',
      data: {}
    })
    
    const selectedType = ref('product')
    const categoryProductPop = ref(false)
    const payload = ref([])
    const sumPayload = ref({})
    const downloadableCsv = ref([])
    const loaded = ref(false)
    const dynamicColumn = ref([])
    return {
      snackbar,
      filter,
      action,
      selectedType,
      categoryProductPop,
      payload,
      sumPayload,
      downloadableCsv,
      loaded,
      dynamicColumn
    }
  },

  watch: {
    vg_selectedLocation(val) {
      // if location selected clear component
      this.clearComponent()
    },
    selectedType() {
      this.payload = []
    }
  },

  computed: {
    ...mapGetters({
      vg_locations: 'location/list',
      vg_selectedLocation: 'location/selected'
    })
  },

  mounted() {
    this.emitter.on('reset-main-sales-component', (data) => {
      this.clearComponent()
    })
  },

  beforeDestroy() {
    this.emitter.off('reset-main-sales-component', () => {})
    this.emitter.off('refresh-main-sales-list', () => {})
  },

  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {}
      }
      let activeItem = document.getElementsByClassName('active-row')
      if (activeItem.length > 0) {
        activeItem[0].classList.remove('active-row')
      }
    },
    selectType(val) {
      this.loaded = false
      this.selectedType = val
    },

    selectFormat(type) {
      this.filter.type.value = type
    },
    openCategoryProductModal() {
      this.categoryProductPop = true
    },
    closeCategoryWithProductModal() {
      this.categoryProductPop = false
    },
    /**
     * Get data selected from category modal
     */
    setCategoriesWithProduct(data) {
      this.filter.products.value = data.pids
      this.closeCategoryWithProductModal()
    },
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.filter, fields)
      // capture the fields
      this.form = res.data
      return res.error ? false : true
    },
    async submit() {
      let fields = []
      if (this.selectedType === 'product') {
        fields = ['fromDate', 'toDate', 'locationIds', 'products']
      } else if(this.selectedType==='order') {
        fields = ['fromDate', 'toDate', 'locationIds', 'invoiceNumber', 'orderReceiveMethod', 'orderReceiveFrom']
      } else if(this.selectedType==='lot') {
        fields = ['fromDate', 'toDate', 'locationIds']
      } else {
        fields = ['fromDate', 'toDate', 'locationIds']
      }
      let validate = await this.validateFields(fields)
      if (!validate) {
        return
      }
      let data = {}
      data.locationIds = this.filter.locationIds.value
      if (this.selectedType === 'product') {
        if(this.filter.products.value.length>0){
          data.products = this.filter.products.value
        }
      }else if(this.selectedType==='order'){
        if(this.filter.invoiceNumber.value.length>0){
          data.invoiceNumber = this.filter.invoiceNumber.value
        }
        data.orderReceiveMethod = this.filter.orderReceiveMethod.value
        data.orderReceiveFrom = this.filter.orderReceiveFrom.value
      } else if(this.selectedType==='lot') {
        if(this.filter.lotNames.value && this.filter.lotNames.value.trim()) {
          data.lotNames = this.filter.lotNames.value.split(',').map(s => s.trim()).filter(Boolean)
        }
      }
      data.fromDate = moment(this.filter.fromDate.value).format('YYYY-MM-DD')
      data.toDate = moment(this.filter.toDate.value).format('YYYY-MM-DD')
      this.vm_spinner(true)
      let res = {}
      let param = Object.entries(data)
        .map(([key, val]) => `${key}=${Array.isArray(val) ? val.join(',') : val}`)
        .join('&')
      if (this.selectedType === 'product') {
        res = await ReportApis.saleSummaryByProduct(data)
      } else if(this.selectedType ==='order') {
        res = await ReportApis.saleSummaryByOrder(param)
      } else if(this.selectedType ==='location') {
        res = await ReportApis.saleSummaryByLocation(param)
      } else if(this.selectedType ==='lot') {
        res = await ReportApis.saleSummaryByLot(data)
      } else {
        res = await ReportApis.saleSummaryByDay(param)
      }
      if (res.status == 200) {
        if(res.data.payload.length>0){
          let tempRows = res.data.payload
          let totalRow = {}
          // add taxes for location only
          if(this.selectedType==='location'){
            for(let i=0; i<res.data.payload.length; i++){
              for(let taxKey of Object.keys(res.data.payload[i].totalTaxByCode)){
                if(!this.dynamicColumn.includes(taxKey)){
                  this.dynamicColumn.push(taxKey)
                }
              }
            }
          }
          // sum the all rows
          for(let i=0; i<tempRows.length; i++){
            // add card type in each row
            if(this.selectedType==='location'){
              tempRows[i] = {...tempRows[i], ...tempRows[i].cardPayments}
              tempRows[i].vis = tempRows[i].cardPayments?.visa
            }
            // add tax in each row
            for(let tax of this.dynamicColumn){
              tempRows[i][tax] = tempRows[i].totalTaxByCode?.[tax]?tempRows[i].totalTaxByCode[tax]:0
            }
            this.SumEachColumn(tempRows[i], totalRow, this.selectedType, this.dynamicColumn)
          }
          this.sumPayload = totalRow
          this.payload = tempRows
        }else{
          this.payload = res.data.payload
        }
        
        this.emitter.emit('reloadSalesList')
        this.loaded = true
      } else {
        this.snackbar.add({
          type: 'info',
          text: 'Data not found!',
          duration: 3000
        })
      }
      this.vm_spinner(false)
    },

    SumEachColumn(row, totalRow, type, dynamicColumn){
      let columns = []
      if(type==='day'){
        columns = ['numOfOrders','numOfRefOrders','netSoldOrders','totalInvoice','grossSales','netSales','totalDiscount','totalOtherDiscount','totalPromotionDiscount','totalPromoCodeDiscount','totalLoyalityRedemption','rewardRedemption','totalRefundAmount','totalTax','totalFees','totalTips','totalCost','grossProfit','grossMargin','totalProductSold','numOfLoyalityRedeem','onlineSales','instoreSales']
      }else if(type==='lot'){
        columns = ['itemsSold','itemsRefunded','netQty','grossSale','subTotal','totalDiscount','totalOtherDiscount','totalPromotionDiscount','totalPromoCodeDiscount','rewardRedemption','totalTax','totalCost','grossProfit','averageRetailPrice','grossMargin']
      }else if(type==='product'){
        columns = ['itemsSold','itemsRefunded','netQty','grossSale','subTotal','totalDiscount','totalOtherDiscount','totalPromotionDiscount','totalPromoCodeDiscount','rewardRedemption','totalTax','totalCost','grossProfit','averageRetailPrice','grossMargin']
      }else if(type==='order'){
        columns = ['totalInvoice','grossSale','subTotal','totalDiscount','totalOtherDiscount','totalPromotionDiscount','totalPromoCodeDiscount','totalMembershipRedemptions','rewardRedemption','totalTax','totalFees','totalTips','totalCost','grossProfit','grossMargin']
      }else if(type==='location'){
        columns = ['numOfOrders','numOfRefOrders','netSoldOrders','totalInvoice','grossSales','netSales','totalDiscount','totalOtherDiscount','totalPromotionDiscount','totalPromoCodeDiscount','totalLoyalityRedemption','rewardRedemption','totalRefundAmount','totalTax','totalFees','totalTips','totalCost','grossProfit','grossMargin','totalProductSold','numOfLoyalityRedeem','cashPayment','amex','master','vis','debit','uber','gift_card','other','onlineSales','instoreSales']
        columns = [...columns, ...dynamicColumn]
      }
      for(let col in row){
        if(columns.includes(col)){
            totalRow[col] = +((totalRow[col]?parseFloat(totalRow[col]):0)+(row[col]?parseFloat(row[col]):0)).toFixed(2)
        }else if(col==='date' && type==='day'){
          totalRow[col] = 'Totals'
        }else if(col==='location' && type==='product'){
          totalRow[col] = 'Totals'
        }else if(col==='location' && type==='lot'){
          totalRow[col] = 'Totals'
        }else if(col==='location' && type==='order'){
          totalRow[col] = 'Totals'
        }else if(col==='locationName' && type==='location'){
          totalRow[col] = 'Totals'
        }else if(col==='cardPayments' || col==='totalTaxByCode'){
          totalRow[col] = {}
        }else{
          totalRow[col] = ''
        }
      }
    },

    async exportReport(){
      this.vm_spinner(true)
      if(!this.payload.length){
        await this.submit()
        
      }
      if(this.payload.length){
        let payloadWithTotal = null
        if(this.payload.length>1){
          payloadWithTotal = [this.sumPayload, ...this.payload]
        }else{
          payloadWithTotal = this.payload
        }

        if(this.selectedType == 'product'){
          this.createProductXlSheet(payloadWithTotal)
        }else if(this.selectedType==='order'){
          this.createInvoiceXlSheet(payloadWithTotal)
        }else if(this.selectedType==='location'){
          this.createLocationXlSheet(payloadWithTotal)
        }else if(this.selectedType==='lot'){
          this.createLotXlSheet(payloadWithTotal)
        }else{
          this.createDayXlSheet(payloadWithTotal)
        }
      }
      this.vm_spinner(false)
    },

    async createProductXlSheet(jsonData){
      try {
        let schema = [
          {
            column: 'Location',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.location ? i.location : '' 
          },
          {
            column: 'Category',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => {
              if(i.category){
                return i.category;
              } else {
                return '';
              }
            }
          },
          {
            column: 'Compliance Type',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.complianceType ? i.complianceType : '' 
          },
          {
            column: 'Licensed Producer',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.licensedProducer ? i.licensedProducer : '' 
          },
          {
            column: 'Brand',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.brand ? i.brand : '' 
          },
          {
            column: 'Product',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.product?i.product:''
          },
          {
            column: 'Variant',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.productVariationName?i.productVariationName:''
          },
          {
            column: 'SKU',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.sku?i.sku:''
          },
          {
            column: 'Items Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.itemsSold
          },
          {
            column: 'Items Refunded',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.itemsRefunded
          },
          {
            column: 'Net Qty Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.netQty
          },
          {
            column: 'Gross Sales',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossSale
          },
          {
            column: 'Net Sales',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.subTotal
          },
          {
            column: 'Total Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalDiscount
          },
          {
            column: 'Total Other Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalOtherDiscount
          },
          {
            column: 'Total Promotion Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromotionDiscount
          },
          {
            column: 'Total Promo Code Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromoCodeDiscount
          },
          {
            column: 'Markdown %',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.markdownPercent
          },
          {
            column: 'Reward Tiers',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.rewardRedemption
          },
          {
            column: 'Total Tax',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalTax
          },
          {
            column: 'Cost of Goods Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalCost
          },
          {
            column: 'Gross Profit',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossProfit
          },
          {
            column: 'Avg Retail Price',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.averageRetailPrice
          },
          {
            column: 'Gross Margin',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossMargin
          }
        ];
        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, {
          schema: schema,
        });
        let fromDate = moment(this.filter.fromDate.value).format('yyyy-MM-dd')
        let toDate = moment(this.filter.toDate.value).format('yyyy-MM-dd')
        let fileName = `Sale-Summary-Product-${fromDate}-${toDate}.xlsx`;
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)
      } catch(err) {
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },

    async createInvoiceXlSheet(jsonData){
      try {
        let schema = [
          {
            column: 'Location',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.location ? i.location : '' 
          },
          {
            column: 'Order ID',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.orderNumber
          },
          {
            column: 'Date & Time',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.completedDate?this.canadaTime(i.completedDate):''
          },
          {
            column: 'Order Status',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.type ? i.type :''
          },
          {
            column: 'POS Station',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.posStationName ? i.posStationName :''
          },
          {
            column: 'Delivery',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.delivery ? i.delivery :''
          },
          {
            column: 'Online/In-Store',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.orderReceiveMethod ? i.orderReceiveMethod :''
          },
          {
            column: 'Platform',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.platform ? i.platform :''
          },
          {
            column: 'Total Receipts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalInvoice
          },
          {
            column: 'Gross Sale',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossSale
          },
          {
            column: 'Net Sales',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.subTotal
          },
          {
            column: 'Total Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalDiscount ? i.totalDiscount :''
          },
          {
            column: 'Total Other Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalOtherDiscount
          },
          {
            column: 'Total Promotion Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromotionDiscount
          },
          {
            column: 'Total Promo Code Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromoCodeDiscount
          },
          {
            column: 'Discount Reason',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.discountReason ? i.discountReason :''
          },
          {
            column: 'Total Membership Redemptions',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalMembershipRedemptions
          },
          {
            column: 'Reward Tiers',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.rewardRedemption
          },
          {
            column: 'Total Tax',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalTax
          },
          {
            column: 'Total Fees',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalFees
          },
          {
            column: 'Total Tips',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalTips
          },
          {
            column: 'Cost of Goods Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalCost
          },
          {
            column: 'Gross Profit',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossProfit ? i.grossProfit :''
          },
          {
            column: 'Gross Margin',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossMargin ? i.grossMargin :''
          },
          {
            column: 'Tendered By',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.tenderedBy ? i.tenderedBy :''
          },
          {
            column: 'Created By',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.createdBy ? i.createdBy :''
          },
          {
            column: 'Customer',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.customer ? i.customer :''
          },
          {
            column: 'Payment Type',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => this.paymentType(i)
          },
        ];
        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, {
          schema: schema,
        });
        let fromDate = moment(this.filter.fromDate.value).format('YYYY-MM-DD')
        let toDate = moment(this.filter.toDate.value).format('YYYY-MM-DD')
        let fileName = `Sale-Summary-Order-${fromDate}-${toDate}.xlsx`;
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)
      } catch(err) {
        console.log(err)
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },

    async createLocationXlSheet(jsonData){
      try {
        let schema = [
          {
            column: 'Location',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.locationName
          },
          {
            column: 'Orders Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.numOfOrders
          },
          {
            column: 'Orders Refunded',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.numOfRefOrders
          },
          {
            column: 'Net Orders Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.netSoldOrders
          },
          {
            column: 'Total Receipts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalInvoice
          },
          {
            column: 'Gross Sales',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossSales
          },
          {
            column: 'Net Sales',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.netSales
          },
          {
            column: 'Total Discount',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalDiscount
          },
          {
            column: 'Total Other Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalOtherDiscount
          },
          {
            column: 'Total Promotion Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromotionDiscount
          },
          {
            column: 'Total Promo Code Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromoCodeDiscount
          },
          {
            column: 'Discount Markdown %',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.discountMarkdown
          },
          {
            column: 'Total Membership Redemptions',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalLoyalityRedemption
          },
          {
            column: 'Reward Tiers',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.rewardRedemption
          },
          {
            column: 'Refunds in $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalRefundAmount
          },
          {
            column: 'Total Tax',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalTax
          },
          {
            column: 'Total Fees',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalFees
          },
          {
            column: 'Total Tips',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalTips
          },
          {
            column: 'Cost of Goods Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalCost
          },
          {
            column: 'Gross Profit',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossProfit
          },
          {
            column: 'Gross Margin',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossMargin
          },
          {
            column: 'Items Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalProductSold
          },
          {
            column: '# of Membership Redemptions',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.numOfLoyalityRedeem
          },
          {
            column: 'Avg Items Sold Per Order',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.avgItemPerTrans
          },
          {
            column: 'Avg item qty per Order',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.avgItemQtyPerTrans
          },
          {
            column: 'Avg Order $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.avgTransaction
          },
          {
            column: 'Cash',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.cashPayment
          },
          {
            column: 'Amex',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.amex ? i.amex.toString() :''
          },
          {
            column: 'Mastercard',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.master ? i.master.toString() :''
          },
          {
            column: 'Visa',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.vis ? i.vis.toString() :''
          },
          {
            column: 'Debit',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.debit ? i.debit.toString() :''
          },
          {
            column: 'Uber',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.uber ? i.uber.toString() :''
          },
          {
            column: 'Gift card',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.gift_card ? i.gift_card.toString() :''
          },
          {
            column: 'Other',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.other ? i.other.toString() :''
          },
          {
            column: 'Online sales $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.onlineSales
          },
          {
            column: 'In-store sales $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.instoreSales
          }
        ];
          for(let tax of this.dynamicColumn){
            schema.push({
              column: tax,
              type: Number,
              wrap: false,
              alignVertical: 'center',
              align: 'center',
              value: i => i[tax]?i[tax]:0
            })
          }
        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, {
          schema: schema,
        });
        let fromDate = moment(this.filter.fromDate.value).format('YYYY-MM-DD')
        let toDate = moment(this.filter.toDate.value).format('YYYY-MM-DD')
        let fileName = `Sale-Summary-Location-${fromDate}-${toDate}.xlsx`;
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)
      } catch(err) {
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },

    async createDayXlSheet(jsonData){
      try {
        let schema = [
          {
            column: 'Date',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.date
          },
          {
            column: 'Location',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.locationName
          },
          {
            column: 'Orders Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.numOfOrders
          },
          {
            column: 'Orders Refunded',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.numOfRefOrders
          },
          {
            column: 'Net Orders Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.netSoldOrders
          },
          {
            column: 'Total Receipts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalInvoice
          },
          {
            column: 'Gross Sales',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossSales
          },
          {
            column: 'Net Sales',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.netSales
          },
          {
            column: 'Total Discount',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalDiscount
          },
          {
            column: 'Total Other Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalOtherDiscount
          },
          {
            column: 'Total Promotion Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromotionDiscount
          },
          {
            column: 'Total Promo Code Discounts',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalPromoCodeDiscount
          },
          {
            column: 'Discount Markdown %',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.discountMarkdown
          },
          {
            column: 'Total Membership Redemptions',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalLoyalityRedemption
          },
          {
            column: 'Reward Tiers',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.rewardRedemption
          },
          {
            column: 'Refunds in $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalRefundAmount
          },
          {
            column: 'Total Tax',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalTax
          },
          {
            column: 'Total Fees',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalFees
          },
          {
            column: 'Total Tips',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalTips
          },
          {
            column: 'Cost of Goods Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalCost
          },
          {
            column: 'Gross Profit',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossProfit
          },
          {
            column: 'Gross Margin',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.grossMargin
          },
          {
            column: 'Items Sold',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.totalProductSold
          },
          {
            column: '# of Membership Redemptions',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.numOfLoyalityRedeem
          },
          {
            column: 'Avg Items Sold Per Order',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.avgItemPerTrans
          },
          {
            column: 'Avg item qty per Order',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.avgItemQtyPerTrans
          },
          {
            column: 'Avg Order $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.avgTransaction
          },
          {
            column: 'Online sales $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.onlineSales
          },
          {
            column: 'In-store sales $',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.instoreSales
          }
        ];
        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, {
          schema: schema,
        });
        let fromDate = moment(this.filter.fromDate.value).format('YYYY-MM-DD')
        let toDate = moment(this.filter.toDate.value).format('YYYY-MM-DD')
        let fileName = `Sale-Summary-day-${fromDate}-${toDate}.xlsx`;
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)
      } catch(err) {
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },

    async createLotXlSheet(jsonData){
      try {
        let schema = [
          { column: 'Location', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.location != null ? i.location : '' },
          { column: 'Category', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.category != null ? i.category : '' },
          { column: 'Compliance Type', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.complianceType != null ? i.complianceType : '' },
          { column: 'Licensed Producer', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.licensedProducer != null ? i.licensedProducer : '' },
          { column: 'Brand', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.brand != null ? i.brand : '' },
          { column: 'Product', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.product != null ? i.product : '' },
          { column: 'Variant', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.productVariationName != null ? i.productVariationName : '' },
          { column: 'SKU', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.sku != null ? i.sku : '' },
          { column: 'LOT / Batch', type: String, wrap: false, alignVertical: 'center', align: 'center', value: i => i.lotName != null ? i.lotName : 'N/A' },
          { column: 'Items Sold', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.itemsSold },
          { column: 'Items Refunded', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.itemsRefunded },
          { column: 'Net Qty Sold', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.netQty },
          { column: 'Gross Sales', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.grossSale },
          { column: 'Net Sales', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.subTotal },
          { column: 'Total Discounts', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.totalDiscount },
          { column: 'Total Other Discounts', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.totalOtherDiscount },
          { column: 'Total Promotion Discounts', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.totalPromotionDiscount },
          { column: 'Total Promo Code Discounts', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.totalPromoCodeDiscount },
          { column: 'Markdown %', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.markdownPercent },
          { column: 'Reward Tiers', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.rewardRedemption },
          { column: 'Total Tax', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.totalTax },
          { column: 'Cost of Goods Sold', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.totalCost },
          { column: 'Gross Profit', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.grossProfit },
          { column: 'Avg Retail Price', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.averageRetailPrice },
          { column: 'Gross Margin', type: Number, wrap: false, alignVertical: 'center', align: 'center', value: i => i.grossMargin },
        ];
        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, { schema })
        let fromDate = moment(this.filter.fromDate.value).format('YYYY-MM-DD')
        let toDate = moment(this.filter.toDate.value).format('YYYY-MM-DD')
        let fileName = `Sale-Summary-lot-${fromDate}-${toDate}.xlsx`
        let url = URL.createObjectURL(xlBlob)
        let link = document.createElement('a')
        link.setAttribute('href', url)
        link.setAttribute('download', fileName)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        let self = this
        setTimeout(function () {
          self.snackbar.add({ type: 'info', text: 'File downloaded', duration: 3000 })
        }, 1000)
      } catch (err) {
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },

    canadaTime(data){
        if(!data) return
        let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
        return moment(data).tz(defaultTimeZone).format('YYYY-MM-DD h:mm a');
    },

    canadaDate(data){
        if(!data) return
        let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
        return moment(data).tz(defaultTimeZone).format('YYYY-MM-DD');
    },
    readableDate(data){
      if(!data) return
      return moment(data).format('YYYY-MM-DD');
    },

    readableDate(str){
      if(!str) return ''
      return moment(str).format('YYYY-MM-DD h:mm a');
    },
    paymentType(data){
      if(data.amex){
        return 'Amex'
      }else if(data.visa){
        return 'Visa'
      }else if(data.mastercard){
        return 'Mastercard'
      }else if(data.debit){
        return 'Debit'
      }else if(data.cash){
        return 'Cash'
      }else if(data.otherCard){
        return 'Other'
      }else{
        return ''
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner'
    }),
    ...mapMutations({
      vm_spinner: 'spinner/mutateSpinner'
    })
  }
})
</script>